import { Badge } from "@windmill/react-ui";

const Status = ({ status ,t }) => {


  return (
    <>
      <span className="font-serif">
        {(status === "Draft") && (
          <Badge type="warning">{t('Draft')}</Badge>
        )}
      
        {status === "New" && <Badge>{t('New')}</Badge>}
        {(status === "Accepted") && (
          <Badge type="success">{t('Accepted')}</Badge>
        )}
        {status === "Rejected" && <Badge type="danger">{t('Rejected')}</Badge>}
        {status === "Expired" && <Badge type="danger">{t('Expired')}</Badge>}
        {status === "Modified" && (
          <Badge className="dark:bg-teal-900 bg-teal-100">{t('Modified')}</Badge>
        )}
       
      </span>
    </>
  );
};

export default Status;
